export class OrganizationDomainRequest {
  domainName: string;

  constructor(domainName: string) {
    this.domainName = domainName;
  }
}
